<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light" v-show="isLogged">
    <router-link to="/" class="navbar-brand">
      <img src="/static/logo.webp" class="img-fluid" style="width:130px" alt="Logo Caqui">
      <small class="text-default">Olá, {{token ? token.nome.split(' ')[0] : ''}}</small>
    </router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav" aria-controls="nav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="nav">
      <ul class="navbar-nav mr-auto">

        <router-link tag="li" class="nav-item" to="/">
          <a data-toggle="collapse" data-target="#nav" class="nav-link">Menu</a>
        </router-link>

        <router-link tag="li" class="nav-item" to="/admin/planos" v-if="token.role === 'ADM'">
          <a data-toggle="collapse" data-target="#nav" class="nav-link">Planos</a>
        </router-link>

        <router-link tag="li" class="nav-item" to="/admin/empresas" v-if="token.role === 'ADM'">
          <a data-toggle="collapse" data-target="#nav" class="nav-link">Empresas</a>
        </router-link>

        <router-link tag="li" class="nav-item" to="/admin/usuarios" v-if="token.role === 'ADM' || token.role === 'CA' ">
          <a data-toggle="collapse" data-target="#nav" class="nav-link">Usuários</a>
        </router-link>

        <router-link tag="li" class="nav-item" to="/perfil">
          <a data-toggle="collapse" data-target="#nav" class="nav-link">Meu Perfil</a>
        </router-link>

        <router-link tag="li" class="nav-item" to="/suporte">
          <a data-toggle="collapse" data-target="#nav" class="nav-link">Suporte</a>
        </router-link>

      </ul>
      <ul class="navbar-nav my-2 my-md-0 mr-md-3 ">
        <li class="nav-item">

          <a href="javascript:;"  class="nav-link" @click="showPanel()">
            <i class="material-icons icone">notifications</i>
            <span  v-if="this.notificacoes.length > 0" v-on:get-notys="getNotys()" class="badge badge-danger">{{this.notificacoes.length}}</span>
          </a>

        </li>
        <li class="ml-3">
        </li>
        <li class="nav-item">
          <router-link title="SAIR" data-toggle="collapse" data-target="#nav" to="/logout" class="nav-link">
            <i class="material-icons icone">exit_to_app</i>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import store from '@/store';
import bus from '@/BUS';

export default {
  name: 'app-nav',
  data() {
    return {
      links: [],
      notificacoes: [],
    };
  },
  methods: {
    async getNotys() {
      const resNotys = await this.$http.post('/notificacoes/list', {});
      this.notificacoes = resNotys.data;
    },
    showPanel() {
      const panel = this.$showPanel({
        component: "panel-1",
        cssClass: "panel-1",
        width: "400px",
      });
    },
    logout() {
      this.$router.go('/logout');
    },
    showOnNav(link) {
      return (
        (
          link.meta &&
          link.meta.showOnNav &&
          !link.meta.alias &&
          this.token.role !== 'ADM' &&
          !link.meta.onlyADM
        )
        ||
        (link.meta && this.token.role === 'ADM' && link.meta.onlyADM)
        ||
        (link.meta && link.meta.alias && this.token.empresaModel && this.token.empresaModel.modulos[link.meta.alias])
      );
    },
    isActive(path) {
      const isIt = this.$route.fullPath.indexOf(path) > -1 && path !== '/';
      return { active: isIt };
    }
  },
  beforeMount() {
    this.links = this.$router.options.routes;
    this.getNotys();

    bus.$on('get-notys', () =>  this.getNotys())
  },
  watch:{
    $route (to, from){
      if (this.token && to.path.indexOf('login') === -1 && from.path.indexOf('logout') === -1)
      this.getNotys();
    }
  }
};
</script>

<style scoped>

.icone {
  color: #014442;
  overflow: hidden;
}

.nav-link {
  font-weight: bold;
  color: #014442 !important;
}

.active a {
  color: #f7931e !important;
}
</style>




// WEBPACK FOOTER //
// src/components/custom/Nav.vue